import axios from 'axios';
import Permission from '@/shared/constants/Permission';
import SnippetType from '@/shared/constants/SnippetType';
import TagType from '@/shared/constants/TagType';
import VehicleType from '@/shared/constants/VehicleType';
import { parseBrands } from '@/shared/converters/brandConverters';
import { parseMobilitySolutions } from '@/shared/converters/mobolitySolutionConverters';
import { parseTags } from '@/shared/converters/tagConverters';
import { parseUsers } from '@/shared/converters/userConverters';
import Brand from '@/shared/models/Brand';
import MobilitySolution from '@/shared/models/MobilitySolution';
import { OutletId } from '@/shared/models/Outlet';
import Snippet from '@/shared/models/Snippet';
import Tag from '@/shared/models/Tag';
import User from '@/shared/models/User';
import { LanguageCode } from '@/shared/models/common';
import { parseSnippets } from '../converters/SnippetConverters';

export default class GeneralClient {
  static async loadUsers(permission?: Permission, includeDeleted = true): Promise<Array<User>> {
    const params = {
      includedeleted: includeDeleted,
      permission: permission ?? null,
    };
    const response = await axios.get('/api/mobopro/v1/outletusers', { params });
    return parseUsers(response.data);
  }

  static async loadBrands(vehicleType: VehicleType): Promise<Array<Brand>> {
    const params = { objectType: vehicleType };
    const response = await axios.get('/api/mobopro/v1/brands', { params });
    return parseBrands(response.data);
  }

  static async loadTags(type: TagType, outletId: OutletId): Promise<Array<Tag>> {
    const params = {
      type,
      moid: outletId,
      settings: false,
    };
    const response = await axios.get('/api/mobopro/v2/tags', { params });
    return parseTags(response.data);
  }

  static async loadMobilitySolutions(outletId: OutletId): Promise<Array<MobilitySolution>> {
    const response = await axios.get(`/api/mobopro/v1/mobooutletmobilitysolutions/${outletId}`);
    return parseMobilitySolutions(response.data);
  }

  static async loadSnippets(type: SnippetType, language?: LanguageCode): Promise<Array<Snippet>> {
    const params = {
      Type: type,
      ...(language ? { Language: language } : {}),
    };
    const response = await axios.get('/api/mobopro/v1/snippets', { params });
    return parseSnippets(response.data);
  }
}